/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'

function Icon({ style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="22"
      fill="none"
      viewBox="0 0 8 22"
      sx={style}
    >
      <path stroke="currentColor" d="M7 1L1 11l6 10" />
    </svg>
  )
}

export default Icon
